<template>
    <!-- 公共按钮 -->
    <div>
        <!-- 搜索弹框 -->
        <el-dialog :visible.sync="vis" title="产品编码" width="40%" :close-on-click-modal="false">
            <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="queryKey"
                      @change="getView"></el-input>
            <el-table
                    header-row-class-name="headerclass"
                    stripe
                    :data="dataSet"
                    border
                    max-height="500"
                    size="mini"
                    :highlight-current-row="true"
                    @row-click="change"
                    @row-dblclick="confirm"
                    @selection-change="handleSelectionChange"
                    style="width: 100%; margin-top: 20px"
                    ref="table"
            >
                <el-table-column type="selection"></el-table-column>
                <el-table-column show-overflow-tooltip prop="productname" label="品名"></el-table-column>
                <el-table-column show-overflow-tooltip prop="productmodel" label="型号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="productspecs" label="规格"></el-table-column>
                <el-table-column show-overflow-tooltip prop="productcode" label="产品唯一编码"></el-table-column>
                <el-table-column show-overflow-tooltip prop="retailprice" label="零售价" align="right"></el-table-column>
                <el-table-column show-overflow-tooltip prop="provincialprice" label="省代价格" align="right"></el-table-column>
                <el-table-column show-overflow-tooltip prop="cityprice" label="市代价格" align="right"></el-table-column>
                <!--<el-table-column show-overflow-tooltip prop="dealeriid" label="经销商ID"></el-table-column>-->
                <el-table-column show-overflow-tooltip prop="status" label="状态"></el-table-column>
                <el-table-column show-overflow-tooltip prop="trackingnum" label="快递单号"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
				<el-row>
					<el-col :span="20">
						<!--<el-pagination
                                @current-change="handleSizeChange"
                                @size-change="handleSizeChange"
                                small
                                layout="prev, pager, next, jumper"
                                :total="total"
                                :pager-count = "5"
                                class="pagesmall"
                        ></el-pagination>-->
                        <el-pagination
                                style="margin-top: 1em"
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="SelectIndexs"
                                :page-sizes="[50, 100, 500, 1000, 1500, 2000, 2500, 3000, 3500,4000,4500,5000,5500,6000,6500,7000,7500,8000,8500,9000,9500,10000]"
                                :page-size="50"
                                :pager-count="5"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total"
                        ></el-pagination>
					</el-col>
					<el-col :span="4"></el-col>
				</el-row>
                <el-button type="primary" @click="confirm" size="mini">确 定</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'item',
        props: {
            isVisible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                dataSet: [],
                total: 0,
                pageSize: 50,
                pageIndex: 1,
                SelectIndexs: 1,
                queryKey: '',
                cache_code: '',
                vis: this.isVisible, // 是否显示弹窗，
                datalist: {}, // 选中某行时记录数据
                isbatch: false, // 是否需要多选
                selectData: [], // 多选数组
                cacheData:[], // 已选择数组
                transferData:[], //传递的数组
                productiid: "", //产品iid
                dealeriid: "", //经销商iid
                orderorsaleiid: "", // 订单或者销售iid
                type: 1, // 1:订单 2：销售
            };
        },

        mounted: function () {
            this.vis = this.isVisible;
        },
        methods: {
            clearInput(e,arr,dealeriid,productiid,orderorsaleiid, type) {
                let that = this
                that.vis = e;
                that.transferData = arr
                that.productiid = productiid
                that.dealeriid = dealeriid
                that.orderorsaleiid = orderorsaleiid
                that.type = type
                that.getView();
            },
            initData(arr) {
                let that = this
                if(arr.length != 0){
                    that.cacheData = []
                    for(let i=0;i<arr.length;i++) {
                        that.cacheData = [...that.cacheData,arr[i].iid]
                    }
                    let self = this;
                    that.dataSet.forEach((row,index)=>{
                        if(that.isInArray(that.cacheData,row.iid)){
                            self.$nextTick(function () {
                                self.$refs.table.toggleRowSelection(this.dataSet[index], true);
                            })
                            /*setTimeout(()=>{
                                this.$refs.multipleTable.toggleRowSelection(this.dataSet[index])
                            },1)*/
                        }
                    })
                } else {
                    that.cacheData = []
                }
            },
            isInArray(arr,value){
                for(let i = 0; i < arr.length; i++){
                    if(value === arr[i]){
                        return true;
                    }
                }
                return false;
            },
            //修改页数
            handleSizeChange(val) {
                this.pageSize = val;
                this.getView();
            },
            //跳页
            handleCurrentChange(val) {
                this.pageIndex = val
                this.SelectIndexs = val;
                this.getView();
            },
            // 获取物料信息
            getView() {
                let that = this
                that.loading = true
                if (that.type == 1){
                    let parm = {
                        PageSize: that.pageSize,
                        PageIndex: that.pageIndex,
                        QueryKey: that.queryKey,
                        iid: "",
                        SortList: that.SortList,
                        ScreenList: that.ScreenList,
                        dealercode: "",
                        productcodestatus: 2,
                        productiid: that.productiid,
                        type: that.orderorsaleiid
                    };
                    that.$http.urlpost('/SysProductCode/View', parm, function (res) {
                        if (res.Success == 1) {
                            that.dataSet = res.DataContent;
                            that.total = res.Totals;
                            that.loading = false;
                            that.initData(that.transferData)
                        } else {
                            that.$message.error(res.Msg);
                        }
                    });
                } else if (that.type == 2) {
                    let parm ={
                        tableName: "v_productcode",
                        columnName: "",
                        iid: that.dealeriid,
                        productiid: that.productiid,
                        type: that.orderorsaleiid,
                        PageSize: that.pageSize,
                        PageIndex: that.pageIndex,
                    }
                    that.$http.urlpost('/BaseData/PCodeByDealeriid', parm, function (res) {
                        if (res.Success == 1) {
                            that.dataSet = res.DataContent;
                            that.total = res.Totals;
                            that.loading = false;
                            that.initData(that.transferData)
                        } else {
                            that.$message.error(res.Msg);
                        }
                    });
                }

            },
            change(row) {
                let that = this;
                that.dataList = row
            },
            confirm() {
                let that = this;
                that.$emit('addproductcode', that.selectData);
                that.vis = false;
            },
            // 批量选择
            handleSelectionChange(val) {
                let that = this;
                console.log(val)
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i].iid);
                }
            },
        }
    };
</script>

<style>
    .contents {
        position: fixed;
        height: 60px;
        top: 0px;
        line-height: 60px;
        right: 7.5rem;
        z-index: 9999;
    }
</style>
